import React, { Component } from "react";
import _ from "lodash";
import moment from "moment";
import { withStyles } from '@material-ui/core/styles';
import Paper from "@material-ui/core/Paper";
import classNames from "classnames";
import Button from "@material-ui/core/Button";
import * as ClaimsService from "../services/claims";
import { getCounties, getReasons } from "../services/nomenclatures";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {
  getTimeFrame
} from "./../services/dashboard";

const styles = () => ({
  root: {
    display: "grid",
    gridRowGap: "20px",
    gridColumnGap: "50px",
    paddingLeft: "5%",
    paddingRight: "5%",
    paddingTop: "20px",
    paddingBottom: "50px",
    boxSizing: "border-box",
    gridTemplateColumns: "1fr 1fr",
    gridTemplateRows: "1fr 1fr 1fr"
  },

  dates: {
    flexDirection: "row",
    width: "100%",
    display: "flex",
    padding: "20px 5%"
  },
  rootPaper: {
    justifySelf: "center",
    backgroundColor: "#FFF",
    fontFamily: "Roboto, sans-serif",
    width: "100%"
  },
  header: {
    padding: "10px",
    fontSize: "1.4rem"
  },
  contentItem: {
    padding: "5px",
    fontSize: "1.2rem"
  },
  appContent: {
    height: "100%"
  }
});

class PublicClaimsDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: null,
      endDate:null,
      interval: null,
      county: "all",
      reason: "Toate",
      avgDay:null,
      counties: [],
      reasons: [],
      claims: [],
      expandedCardList: [],
      chartData: {}
    };
    this.enableAutoload = this.enableAutoload.bind(this);
    this.disableAutoload = this.disableAutoload.bind(this);
    this.handleChangeEnd = this.handleChangeEnd.bind(this);
    this.handleChangeStart = this.handleChangeStart.bind(this);
  }

  enableAutoload() {
    const setTimer = window.setInterval(() => {
      this.iRunEveryThreeMinutes();
    }, 180000);
    this.setState({ interval: setTimer });
  }

  disableAutoload() {
    //console.log("Clearing the timer from state...");
    const clearTimer = window.clearInterval(this.state.interval);
    this.setState({ interval: clearTimer });
  }

  async iRunEveryThreeMinutes() {
    await this.reLoad();
    //console.log("Hello There. We refreshed the requests", new Date());
  }

  async reLoad() {
    let claims = await ClaimsService.getAllClaims();
    let resolved = [];
    let waiting = [];
    let closed = [];
    var filteredClaims = []
    if (this.state.startDate && this.state.endDate) {
      var sD =  moment(this.state.startDate);
      var eD =  moment(this.state.endDate);
      for (var j = 0; j < claims.length; j++) {
        
        if (moment(claims[j].created).startOf('day').diff(sD.startOf('day'), 'days')>=0 && moment(claims[j].created).startOf('day').diff(eD.startOf('day'), 'days')<=0) {
          filteredClaims.push(claims[j]);
        } 
      }
      claims = filteredClaims;
    }
    for (var i = 0; i < claims.length; i++) {
      if (claims[i].active && claims[i].resolved) {
        let resolvedClaim = claims[i];
        resolvedClaim.duration = moment(claims[i].resolvedDate).diff(
          claims[i].created,
          "day",
          false
        );
        resolvedClaim.createdMonth = moment(claims[i].created).format(
          "MMMM YYYY"
        );
        resolvedClaim.resolvedMonth = moment(claims[i].resolvedDate).format(
          "MMMM YYYY"
        );
        resolvedClaim.createdMonthNo = moment(claims[i].created).format(
          "YYYYMM"
        );
        resolvedClaim.resolvedMonthMo = moment(claims[i].resolvedDate).format(
          "YYYYMM"
        );
        resolved.push(resolvedClaim);
      }
      if (claims[i].active && !claims[i].resolved) {
        let waitingClaim = claims[i];
        waitingClaim.duration = moment().diff(claims[i].created, "day", false);
        waitingClaim.createdMonth = moment(claims[i].created).format(
          "MMMM YYYY"
        );
        waitingClaim.createdMonthNo = moment(claims[i].created).format(
          "YYYYMM"
        );
        waiting.push(waitingClaim);
      }
      if (!claims[i].active && !claims[i].resolved) {
        let closedClaim = claims[i];
        if (!closedClaim.reasonClose) {
          closedClaim.reasonClose = "nespecificat (cereri gresite/fara motiv)";
        }
        closedClaim.duration = moment().diff(claims[i].created, "day", false);
        closedClaim.createdMonth = moment(claims[i].created).format(
          "MMMM YYYY"
        );
        closedClaim.createdMonthNo = moment(claims[i].created).format("YYYYMM");
        closed.push(closedClaim);
      }
    }
    waiting = _.sortBy(waiting, "duration").reverse();
    resolved = _.sortBy(resolved, "duration").reverse();
    var closedMotives = _.chain(closed)
      .groupBy("reasonClose")
      .toPairs()
      .map(function(currentData) {
        return _.zipObject(["reasonClose", "requests"], currentData);
      })
      .value();

    var createdMonth = _.chain(_.sortBy(claims, "createdMonthNo"))
      .groupBy("createdMonth")
      .toPairs()
      .map(function(currentData) {
        return _.zipObject(["createdMonth", "requests"], currentData);
      })
      .value();
    var resolvedMonth = _.chain(_.sortBy(resolved, "resolvedMonthNo"))
      .groupBy("resolvedMonth")
      .toPairs()
      .map(function(currentData) {
        return _.zipObject(["resolvedMonth", "requests"], currentData);
      })
      .value();

    var maxResolved = _.maxBy(resolved, "duration") || 0;
    var maxWaiting = _.maxBy(waiting, "duration") || 0;
    var avgResolved = Math.round(_.meanBy(resolved, "duration")) || 0;

    if (claims) {
      claims.filter(claim => claim.type === "public");
    } else {
      claims = [];
    }

    this.setState({
      claims,
      resolved,
      waiting,
      closed,
      closedMotives,
      createdMonth,
      resolvedMonth,
      maxResolved,
      maxWaiting,
      avgResolved
    });
    if (this.state.startDate && this.state.endDate && 
      moment(this.state.startDate)
        .format("YYYY-MM-DD") === moment(this.state.endDate)
        .format("YYYY-MM-DD")) {
    const thisWeek = await getTimeFrame(
      moment(this.state.startDate)
        .format("YYYY-MM-DD"),
      moment(this.state.startDate).add(1, "day")
        .format("YYYY-MM-DD")
    );
   
    if (thisWeek[moment(this.state.startDate)
      .format("YYYY-MM-DD")] && thisWeek[moment(this.state.startDate)
        .format("YYYY-MM-DD")].avg){
      this.setState({avgDay: thisWeek[moment(this.state.startDate)
        .format("YYYY-MM-DD")].avg});
    } else {
      this.setState({avgDay:28});
    }
  } else this.setState({avgDay:null})


  }

  async componentWillMount() {
    this.enableAutoload();

    await this.reLoad();

    let counties = await getCounties();
    if (!counties) {
      counties = [];
    }
    let reasons = await getReasons();
    if (!reasons) {
      reasons = [];
    }
    this.setState({
      counties: [
        {
          code: "all",
          name: "Toate"
        },
        ...counties
      ],
      reasons: ["Toate", ...reasons]
    });
  }
  async handleChangeStart(date) {
    this.setState({
      startDate: date
    });
    if (date && this.state.endDate) {
      await this.reLoad();
    }
  }
  async handleChangeEnd(date) {
    this.setState({
      endDate: date
    });
    if (this.state.startDate && date) {
      await this.reLoad();
    }
  }

  render() {
    const { classes, className } = this.props;
    return (
      <div>
        <div
          style={{ flexDirection: "row",  display: "flex", alignItems:"center", padding: "20px 5%", flex: 1, width: "100%" }}
        >
          <DatePicker
            selected={this.state.startDate}
            selectsStart
            startDate={this.state.startDate}
            endDate={this.state.endDate}
            minDate={new Date("12/01/2018")}
            maxDate={new Date()}
            dateFormat="dd/MM/yyyy"
            onChange={this.handleChangeStart}
            placeholderText="Data inceput" 
          />

          <DatePicker
            selected={this.state.endDate}
            selectsEnd
            startDate={this.state.startDate}
            endDate={this.state.endDate}
            dateFormat="dd/MM/yyyy"
            minDate={this.state.startDate}
            maxDate={new Date()}
            onChange={this.handleChangeEnd}
            placeholderText="Data starsit"
          />
          <Button
          variant="contained"
          size="small"
          color="default"
          onClick={() => {this.setState({ startDate: null, endDate:null });   this.reLoad();}}
        >
         Reset
        </Button>
        {this.state.avgDay &&   <p className={classes.header}>
        PATURI OCUPATE {moment(this.state.startDate).format('DD/MM/YYYY')}: <b>{this.state.avgDay}</b>
      </p>}
        </div>
        <div className={classNames(classes.root, className)}>
          <Paper className={classNames(classes.rootPaper, className)}>
            <p className={classes.header}>
              NUMAR TOTAL DE CERERI:{" "}
              <b>{this.state.claims && this.state.claims.length}</b>
            </p>
            <ul>
              {this.state.createdMonth &&
                this.state.createdMonth.map((item, i) => {
                  return (
                    <li key={i} className={classes.contentItem}>
                      {item.createdMonth}
                      {" - "}
                      <b>{item.requests.length}</b>
                      {" cereri"}
                    </li>
                  );
                })}
            </ul>
          </Paper>
          <Paper className={classNames(classes.rootPaper, className)}>
            <p className={classes.header}>
              NUMAR TOTAL CERERI ACCEPTATE:{" "}
              <b>{this.state.resolved && this.state.resolved.length}</b>
            </p>
            <ul>
              {this.state.resolvedMonth &&
                this.state.resolvedMonth.map((item, i) => {
                  return (
                    <li key={i} className={classes.contentItem}>
                      {item.resolvedMonth}
                      {" - "}
                      <b>{item.requests.length}</b>
                      {" cereri"}
                    </li>
                  );
                })}
            </ul>
          </Paper>
          <Paper className={classNames(classes.rootPaper, className)}>
            <p className={classes.header}>
              NUMAR TOTAL CERERI INCHISE:{" "}
              <b>{this.state.closed && this.state.closed.length}</b>
            </p>
            <ul>
              {this.state.closedMotives &&
                this.state.closedMotives.map((item, i) => {
                  return (
                    <li key={i} className={classes.contentItem}>
                      {item.reasonClose}
                      {" - "}
                      <b>{item.requests.length}</b>
                      {" cereri"}
                    </li>
                  );
                })}
            </ul>
          </Paper>
          <Paper className={classNames(classes.rootPaper, className)}>
            <p className={classes.header}>
              CERERI AFLATE IN ASTEPTARE:{" "}
              <b>{this.state.waiting && this.state.waiting.length}</b>
            </p>
            <ul>
              <li className={classes.contentItem}>
                Cea mai veche in asteptare
                {" - "}
                <b>{this.state.maxWaiting && this.state.maxWaiting.duration}</b>
                {" zile"}
              </li>
              <li className={classes.contentItem}>
                Timp mediu de asteptare
                {" - "}
                <b>{this.state.avgResolved}</b>
                {" zile"}
              </li>
              <li className={classes.contentItem}>
                Cea mai lunga asteptare
                {" - "}
                <b>
                  {this.state.maxResolved && this.state.maxResolved.duration}
                </b>
                {" zile"}
              </li>
            </ul>
          </Paper>
        </div>
      </div>
    );
  }

  refresh = async () => {
    const claims = await ClaimsService.getAllClaims();
    this.setState({
      claims
    });
  };
}

export default withStyles(styles)(PublicClaimsDashboard);
